import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1897f6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1897f6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1897f6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1897f6a')) {
      api.createRecord('b1897f6a', component.options)
    } else {
      api.reload('b1897f6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1897f6a&scoped=true", function () {
      api.rerender('b1897f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/layouts/index.vue"
export default component.exports